var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSello(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.508,
    height: 80.508,
    viewBox: "0 0 80.508 80.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13226",
    "data-name": "Grupo 13226",
    transform: "translate(-431.521 -36.128)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_949",
    "data-name": "Elipse 949",
    cx: 40.254,
    cy: 40.254,
    r: 40.254,
    transform: "translate(431.521 36.128)",
    fill: "#a01779"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28584",
    "data-name": "Grupo 28584",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111948",
    "data-name": "Trazado 111948",
    d: "M452.975,58.85l-2.061-.554.735-2.741,5.122,1.373-4.154,15.493-3.06-.82Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111949",
    "data-name": "Trazado 111949",
    d: "M465.522,58.956c4.378,1.173,4.838,4.9,3.635,9.38-1.213,4.527-3.479,7.541-7.857,6.368s-4.832-4.918-3.619-9.445C458.884,60.774,461.143,57.781,465.522,58.956Zm-.741,2.762c-2.508-.672-3.455,1.671-4.168,4.327-.74,2.763-1.081,5.223,1.427,5.9s3.444-1.629,4.185-4.391C466.937,64.893,467.288,62.391,464.781,61.718Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111950",
    "data-name": "Trazado 111950",
    d: "M479.252,62.637c4.377,1.173,4.837,4.895,3.634,9.38-1.213,4.527-3.48,7.542-7.857,6.368s-4.833-4.918-3.62-9.445C472.612,64.455,474.873,61.463,479.252,62.637Zm-.741,2.762c-2.509-.672-3.456,1.67-4.169,4.328-.741,2.762-1.081,5.222,1.427,5.9s3.444-1.628,4.184-4.391C480.666,68.574,481.017,66.071,478.511,65.4Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111951",
    "data-name": "Trazado 111951",
    d: "M497.39,68.478l2.911.782L487.959,81.9l-2.89-.775ZM490.1,66.253a3.576,3.576,0,1,1-4.3,2.537A3.308,3.308,0,0,1,490.1,66.253Zm-2.114,3.123c-.312,1.169,0,1.8.719,1.993.744.2,1.349-.185,1.662-1.354s-.022-1.784-.767-1.983C488.883,67.839,488.3,68.207,487.99,69.376Zm9.17,7.857a3.577,3.577,0,1,1-4.3,2.537A3.276,3.276,0,0,1,497.16,77.233Zm-2.155,3.114c-.319,1.189.016,1.8.761,2,.722.193,1.322-.171,1.64-1.361.314-1.169-.023-1.783-.746-1.976C495.916,78.813,495.318,79.178,495.005,80.347Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_28585",
    "data-name": "Grupo 28585",
    style: {
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111952",
    "data-name": "Trazado 111952",
    d: "M457.266,84.837c-.657,2.448-2.765,3.586-5.351,2.892l-2.831-.758,2.171-8.1,2.831.759C456.672,80.327,457.925,82.378,457.266,84.837Zm-5.04,1.5a2.508,2.508,0,0,0,3.381-1.941,2.534,2.534,0,0,0-1.947-3.406l-1.147-.308-1.434,5.347Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111953",
    "data-name": "Trazado 111953",
    d: "M459.118,82.773l1.624.436-1.723,6.426-1.624-.436Zm.286-1.763a1.034,1.034,0,1,1,.743,1.219A.987.987,0,0,1,459.4,81.01Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111954",
    "data-name": "Trazado 111954",
    d: "M464.887,84.208a2.6,2.6,0,0,1,1.848,1.59l.245-.917,1.636.439-1.735,6.472a3.04,3.04,0,0,1-4.014,2.268c-1.809-.485-2.832-1.728-2.6-3.246l1.613.433a1.718,1.718,0,0,0,3.365.106l.268-1a2.627,2.627,0,0,1-2.406.487,3.16,3.16,0,0,1-2.039-4.128A3.116,3.116,0,0,1,464.887,84.208Zm.035,1.539a1.776,1.776,0,0,0-2.2,1.413,1.819,1.819,0,0,0,1.182,2.368,1.968,1.968,0,0,0,1.014-3.781Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111955",
    "data-name": "Trazado 111955",
    d: "M470.2,85.745l1.624.435L470.1,92.606l-1.624-.436Zm.286-1.764a1.034,1.034,0,1,1,.743,1.219A.988.988,0,0,1,470.486,83.981Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111956",
    "data-name": "Trazado 111956",
    d: "M473.321,88.011l-.765-.205.357-1.334.766.205.425-1.589,1.636.439-.426,1.589,1.439.385-.358,1.334-1.438-.385-.833,3.108c-.115.429.009.662.518.8l.755.2-.367,1.368-1.02-.274a1.847,1.847,0,0,1-1.519-2.545Z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111957",
    "data-name": "Trazado 111957",
    d: "M480.467,88.386a2.63,2.63,0,0,1,1.848,1.589l.245-.916,1.636.438-1.722,6.426-1.636-.439.252-.939a2.626,2.626,0,0,1-2.414.472,3.157,3.157,0,0,1-2.028-4.124A3.116,3.116,0,0,1,480.467,88.386Zm.035,1.538a1.775,1.775,0,0,0-2.2,1.413,1.817,1.817,0,0,0,1.181,2.368,1.968,1.968,0,0,0,1.014-3.781Z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_111958",
    "data-name": "Trazado 111958",
    d: "M486.357,87.765l1.625.435-2.3,8.583-1.625-.435Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_950",
    "data-name": "Elipse 950"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3520",
    "data-name": "Elipse 3520",
    cx: 35.918,
    cy: 35.918,
    r: 35.918,
    transform: "translate(435.856 40.464)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3521",
    "data-name": "Elipse 3521",
    cx: 34.918,
    cy: 34.918,
    r: 34.918,
    transform: "translate(436.856 41.464)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSello);
export default __webpack_public_path__ + "static/media/Sello.42656999096a8513c855ea86a1610eca.svg";
export { ForwardRef as ReactComponent };